/*
submitExcellent.js
请求excellent接口
 */
import {message} from "antd";

import BaseURL from "../BaseURL";

const submitExcellent = async (
    {
        query = '',
        answer = '',
        history_query = '',
        history_response = '',
        user = '',
    }
) => {
    try {
        const response = await BaseURL.post('api/feedback/excellent/', {
            'query': query,
            'response': answer,
            'history_query': history_query,
            'history_response': history_response,
            'user': user,
        });
        const response_data = response.data;
        if (response_data.code === 200) {
            message.success('反馈成功');
        } else {
            message.error('反馈失败，请稍后再试');
        }
    } catch (error) {
        console.log(error);
        message.error('反馈失败，请稍后再试');
    }
};

export default submitExcellent;